import module from '../module';
import * as _ from 'lodash';
import moment from 'moment';
import Constants from '../../../utils/CommonConstants';
import scopeUtils from '../../../utils/scope';


class OrderTabBudgetController {
    static $inject = [
        '$scope', 'cartonomyConfig', '$filter', 'OrderDateService',
        'CheckoutService', 'CartService', 'GroupOrder',
        '$location', '$window', 'Message'];

    constructor($scope, cartonomyConfig, $filter, orderDateServicePromise,
                checkoutService, cartService, groupOrderService,
                $location, $window, messageService) {

        this._scope = $scope;
        this._cartonomyConfig = cartonomyConfig;
        this._filterService = $filter;
        this._checkoutService = checkoutService;
        this._cartService = cartService;
        this._groupOrderService = groupOrderService;
        this._locationService = $location;
        this._windowService = $window;
        this._messageService = messageService;
        this._orderDateServicePromise = orderDateServicePromise;

        $scope.externalStoreMode = cartonomyConfig.externalStoreMode;
        $scope.maxAllowedBudget = 100000;

        this._joinDateTime = () => {
            return null;
        };

        $scope.parentBack = $scope.back;

        $scope.back = (form) => this._back(form);

        $scope.acceptSinglePayOrderNoBudget = form => this._acceptSinglePayOrderNoBudget(form);
        $scope.acceptSinglePayOrderNoPayment = form => this._acceptSinglePayOrderNoPayment(form);
        $scope.onBudgetChanged = () => this._onBudgetChanged();
        $scope.acceptSinglePayOrderBudget = form => this._acceptSinglePayOrderBudget(form);
        $scope.acceptPaymentInformation = () => this._acceptPaymentInformation();

        $scope.shouldDisablePaymentInformationNextButton = () => this._shouldDisablePaymentInformationNextButton();

        $scope.$watch('configuration.paymentSystem', paymentSystem => this._onPaymentSystemChanged(paymentSystem));
    }

    async $onInit() {
        await this._initialize();
    }

    async _initialize() {
        this._scope.configuration = {
            groupPay: this._groupOrderService.getGroupPay(),
            singlePayOrder: this._groupOrderService.getSinglePayOrder() || {
                paymentInformation: {}
            },
            paymentSystem: this._groupOrderService.getPaymentSystem(),
            vendorDetails: this._groupOrderService.getVendorDetails() || {},
            deliveryDetails: this._groupOrderService.getDeliveryDetails(),
        };

        if (this._scope._editMode) {
            this.cart = await this._cartService.getCart();

            if (!this._scope.configuration.singlePayOrder.budget) {
                this._scope.configuration.singlePayOrder.budget = this.cart.orderLimit;
            }
        }

        // stick a $ in front if not there
        if ((_.isString(this._scope.configuration.singlePayOrder.budget) &&
                this._scope.configuration.singlePayOrder.budget.match(/^\d/)) || (this._scope.configuration.singlePayOrder.budget > 0 )) {
            this._scope.configuration.singlePayOrder.budget = parseFloat(this._scope.configuration.singlePayOrder.budget);
            this._scope.configuration.singlePayOrder.defineBudget = 'yes';
            this._scope.configuration.singlePayOrder.budgetEntered = true;
        } else {
            this._scope.configuration.singlePayOrder.budget = "";
            this._scope.configuration.singlePayOrder.defineBudget = 'no';
        }

        if (this._scope.returnToPreview) {
            this._scope.configuration.singlePayOrder.defineBudget = 'yes';
        }

        this._scope.configuration.paymentProvided = await this._checkoutService.paymentAuthorizedOrCaptured();

        if (this._scope.externalStoreMode && !this._scope.configuration.singlePayOrder.enterPaymentInformation) {
            this._scope.configuration.singlePayOrder.enterPaymentInformation = 'no';
        }
    }

    save() {
        this._groupOrderService.setSinglePayOrder(this._scope.configuration.singlePayOrder);
        this._groupOrderService.setVendorDetails(this._scope.configuration.vendorDetails);
        this._groupOrderService.setPaymentSystem(this._scope.configuration.paymentSystem);
    }

    saveAndGotoNext() {
        this.save();
        this._scope.next();
    }

    _rejectSinglePayOrderPlace() {
        if (!this._scope._editMode) {
            // this._scope.configuration.deliveryDetails.placeEntered = false;
        }
    }

    _back(form) {
        if (form && !form.$valid) {
            form.highlightAllErrors();
            return;
        }

        this._scope.parentBack();
    }

    _acceptSinglePayOrderNoBudget(form) {
        if (form && !form.$valid) {
            form.highlightAllErrors();
            return;
        }

        this._scope.configuration.singlePayOrder.budget = 0;

        this.saveAndGotoNext();

        scopeUtils.apply(this._scope);
    }

    async _acceptSinglePayOrderNoPayment(form) {
        if (form && !form.$valid) {
            form.highlightAllErrors();
            return;
        }

        this._scope.budgetExceeds = false;
        this._scope.budgetMaximumReach = false;
        await this._onBudgetChanged();

        if (!this._scope.budgetExceeds && !this._scope.budgetMaximumReach) {
            this.saveAndGotoNext();
        }
    }

    async _onBudgetChanged() {
        if (this._scope.configuration.singlePayOrder.budget && _.isString(this._scope.configuration.singlePayOrder.budget)) {
            this._scope.configuration.singlePayOrder.budget = this._scope.configuration.singlePayOrder.budget.replace(/[^0-9.]/g, "");
            this._scope.configuration.singlePayOrder.budgetEntered = true;
        } else {
            this._scope.configuration.singlePayOrder.budgetEntered = false;
        }

        if (this._scope.externalStoreMode && !this._scope.configuration.singlePayOrder.enterPaymentInformation) {
            this._scope.configuration.singlePayOrder.enterPaymentInformation = 'no';
        }

        this._scope.budgetExceeds = false;
        this._scope.budgetMaximumReach = false;

        let currentAmount = await this._cartService.getCartAmount();
        if (this._scope.configuration.singlePayOrder.budget < currentAmount) {
            this._scope.budgetExceeds = currentAmount;
        }
        if (this._scope.configuration.singlePayOrder.budget > this._scope.maxAllowedBudget) {
            this._scope.budgetMaximumReach = true;
        }

        scopeUtils.apply(this._scope);
    }

    async _acceptSinglePayOrderBudget(form) {
        if (!form.$valid) {
            form.highlightAllErrors();
            return;
        }

        // only digits and decimal point
        if (_.isString(this._scope.configuration.singlePayOrder.budget)) {
            this._scope.configuration.singlePayOrder.budget = this._scope.configuration.singlePayOrder.budget.replace(/[^0-9.]/g, "");
            this._scope.configuration.singlePayOrder.budgetEntered = true;
        } else {
            this.saveAndGotoNext();
        }
    }

    _shouldDisablePaymentInformationNextButton() {
        if (!this._scope.configuration.paymentSystem) {
            return true;
        }

        if (this._scope.configuration.paymentSystem
            && this._scope.configuration.paymentSystem == 'PayPal'
            && !this._scope.configuration.vendorDetails.clientToken) {

            return true;
        }

        return this._scope.configuration.paymentSystem == '';
    }

    _onPaypalSelected() {
        this._scope.processingPayment = true;
        this.save();
        this._groupOrderService.saveToSessionStorage();
        // this._windowService.onbeforeunload = null;
        window.location.href = Constants.PAYPAL_CHECKOUT_URL + this._scope.configuration.vendorDetails.clientToken;
    }

    async _onCreditCardSelected() {

        this._scope.processingPayment = true;
        this._scope.paymentSystemError = '';
        scopeUtils.apply(this._scope);

        try {

            this._scope.configuration.vendorDetails = await this._scope.configuration.getCardNonce();
            this._scope.configuration.vendorDetails.isAuthorization = true;
            this._scope.configuration.vendorDetails.orderTotal = this._scope.configuration.singlePayOrder.budget;

            await this._checkoutService.submitOrder(this._scope.configuration.paymentSystem,
                this._scope.configuration.vendorDetails);

        } catch (error) {
            this._scope.paymentSystemError = "client.payment.credit_trans_not_approved";

            this._scope.processingPayment = false;
            scopeUtils.apply(this._scope);
            return null;
        }

        this._scope.processingPayment = false;
        scopeUtils.apply(this._scope);

        this.saveAndGotoNext();
    }

    async _acceptPaymentInformation() {
        switch (this._scope.configuration.paymentSystem) {
            case 'PayPal':
                return this._onPaypalSelected();
            case 'Square':
                return await this._onCreditCardSelected();
        }
    }

    async _onPaymentSystemChanged(paymentSystem) {

        if (!paymentSystem) {
            this._scope.processingPayment = false;
            return null;
        }

        this._scope.processingPayment = true;
        this._scope.paymentSystemError = '';
        scopeUtils.apply(this._scope);

        try {
            await this._groupOrderService.save();
            const paymentConfiguration = await this._checkoutService.beginCheckout(paymentSystem);
            this._scope.configuration.vendorDetails.clientToken = paymentConfiguration.clientToken;
        } catch (error) {
            this._scope.paymentSystemError = this._messageService.getMessageFromErrorResponse(error);
        }

        this._scope.processingPayment = false;
        scopeUtils.apply(this._scope);
    }
}

module.controller('OrderTabBudget', OrderTabBudgetController);



// WEBPACK FOOTER //
// ./src/modules/order/controllers/OrderTabBudgetController.js